import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { ApiStatus } from "src/app/models/api";
import { W2EmailCriteria, W2Item, W2Model } from "src/app/models/w2";
import { TableColumn } from "src/app/models/table";
import { DocumentService } from "src/app/services/documents.service";
import { HelperService } from "src/app/services/helper.service";
import { EmailDocumentDialogModel } from "src/app/models/dialog";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { DialogEmailDocumentComponent } from "../../shared/dialog/email-document.component";
import { EmailDialogType } from "src/app/constants/email-dialog-type";

@Component({
    selector: "mwp-w2-form",
    templateUrl: "./w2-forms.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentW2FormsComponent implements OnInit {
    public apiUrl = ContentHeaderKey.DocumentsW2;
    public w2FormsList: W2Item[];
    public apiStatus = new ApiStatus();

    public w2MatTableData: MatTableDataSource<W2Item>;
    public w2Columns: TableColumn[] = [
        {
            columnName: 'File Name',
            propertyId: 'fileName',
            columnType: TableColumnType.label,
            width: '25%'

        },
        {
            columnName: 'Year',
            propertyId: 'year',
            columnType: TableColumnType.label,
            width: '28%'
        },
        {
            columnName: 'Actions',
            propertyId: 'fileType',
            columnType: TableColumnType.button,
            dataTypeText: "Download",
            width: '11%',

        },
        {
            columnName: '',
            propertyId: 'w2ID',
            columnType: TableColumnType.button,
            dataTypeText: "Email",
            isButtonSelection2: true,
            width: '11%',

        },

    ];
    constructor(
        private documentService: DocumentService,
        private helperService: HelperService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.documentService.getW2s().subscribe((response: W2Model) => {
            this.w2MatTableData = new MatTableDataSource<W2Item>();
            this.w2MatTableData.data = response.w2Items;
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }

    public downloadW2(w2Item: W2Item): void {
        this.documentService.getW2Download(w2Item.w2ID).subscribe((response: Blob) => {
            let l_BinaryData = [];
            l_BinaryData.push(response);
            this.helperService.downloadDocument(l_BinaryData, response.type, `${w2Item.fileName}${w2Item.fileType}`);
        }
        );
    }

    public emailDocument(w2Item: W2Item) {
        const dialogRef = this.dialog.open(DialogEmailDocumentComponent, {
            data: EmailDialogType.w2,
            panelClass: 'mwp-modal-override-800'
        });

        dialogRef.afterClosed().subscribe((response: EmailDocumentDialogModel) => {
            if (response != null) {
                const l_W2EmailCriteria = new W2EmailCriteria();
                l_W2EmailCriteria.w2ID = w2Item.w2ID;
                l_W2EmailCriteria.toAddress = response.email;
                this.documentService.sendW2ToEmail(l_W2EmailCriteria).subscribe(() => { });
            }
        });
    }
}
